const FIELD_SVG_URL = '/img/session-recap-field.svg';

/** illustration units, home plate tip */
export const FIELD_HOME = { x: 207.655, y: 353.268 };

export const FIELD_WIDTH = 416;
export const FIELD_HEIGHT = 391;

/** illustration units per foot, with the centre field fence (y = 0) at 400 ft */
export const FIELD_UNITS_PER_FT = FIELD_HOME.y / 400;

/** fair territory: both foul lines and the outfield fence */
export const FAIR_TERRITORY_PATH =
  'M207.655 353.268 L0.517 145.408 C9.503 107.54 120.022 0 207.652 0 C295.283 0 405.802 107.54 414.788 145.408 Z';

/** outer edge of the infield dirt, including the wrap around home plate */
export const INFIELD_PATH =
  'M207.659 220.575C252.607 221.263 275.829 250.61 284.395 274.556L284.396 274.558L284.929 276.094V276.096C285.173 276.824 285.405 277.548 285.622 278.265L285.662 278.399L285.562 278.499L216.868 347.192C217.094 347.602 217.296 348.027 217.467 348.467C217.924 349.646 218.176 350.93 218.176 352.271V352.271C218.175 358.08 213.464 362.79 207.655 362.79C201.847 362.789 197.138 358.08 197.137 352.271V352.271C197.137 350.93 197.387 349.646 197.845 348.467C198.015 348.027 198.216 347.602 198.441 347.193L129.647 278.399L129.688 278.265C129.905 277.548 130.137 276.824 130.381 276.096L130.382 276.094L130.914 274.558L130.915 274.556C139.481 250.61 162.704 221.263 207.652 220.575H207.659Z';

export const FieldIllustration = () => (
  <image
    className="recap-field-art"
    href={FIELD_SVG_URL}
    width={FIELD_WIDTH}
    height={FIELD_HEIGHT}
    pointerEvents="none"
  />
);
